import ComptesListView from "@/pages/super-admin/components/ComptesListView";

export default function SuperAdminProprietairesPage() {
  return <ComptesListView type="proprietaire" />;
}